import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetCampusClasses } from '../models/campusClasses4.model';

const uri = '/mgmt/campus-classes';

export const getCampusClasses = (campusCode: string): AxiosPromise<IGetCampusClasses> => {
  return axios.get(`${uri}/${campusCode}`);
};
